import React from 'react'
import { Popup } from '../../../../library/popup'
import { useDispatch, useSelector } from 'react-redux'
import { changeCampaignsModal, requestDeleteEmailChannelDomain } from '../../../../../redux/actions/campaigns'
import { TransparentButton, SolidButton } from '../../../../library/button'

import './style.scss'

const Index = () => {

    const dispatch = useDispatch()

    const modalState = useSelector(state => state.campaigns.showModals.deleteDomainModal)
    const companyId = useSelector(state => state && state.activeCompany && state.activeCompany.activeCompany && state.activeCompany.activeCompany.id)

    const activeChannel = useSelector(state => state.campaigns.activeChannel)
	const loading = useSelector(state => state.campaigns.deleteEmailChannelDomain.loading)

    const handleClose = () => {
        dispatch(changeCampaignsModal({deleteDomainModal: false}))
    }

    const clickDeleteDomain = () => {
        dispatch(requestDeleteEmailChannelDomain({channelId: activeChannel.id, companyId, companyId, username: activeChannel.username}))
    }

    return(
        <Popup 
			onClose={handleClose}
			show={modalState} 
			title="Vil du slette dette domenet?"
			description="Dersom du sletter domenet kan du alltids legge til det samme igjen ved en senere anledning."
			buttons={[
				<TransparentButton title="Avbryt" type="button" data-dismiss="modal" onClick={() => handleClose()} />,
				<SolidButton color="red" title={loading ? "Sletter..":"Ja, slett domenet"} icon={loading ? <i className="fas fa-circle-notch fa-spin"></i>:<i class="fad fa-trash-alt"/>} onClick={() => clickDeleteDomain()} type="button"/>
			]}
		/>
    )
}

export default Index

